import React, { useEffect } from "react";
import { Button, FormHelperText, ListItem } from "@mui/material";
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

export interface DefaultUploadFilesProps {
    setFilesUpload: (file: File[]) => void,
    files: File[],
    extensions?: string[],
    maxFileSizeMb?: number,
}

export default function DefaultUploadFiles(props: DefaultUploadFilesProps) {
    const [selectedFiles, setSelectedFiles] = React.useState<File[]>(props.files);
    const [errorFile, setErrorFile] = React.useState<string>();

    useEffect(() => {
        if (props.files.length === 0) {
            setSelectedFiles([] as File[]);
        } else {
            setSelectedFiles(props.files);
        }
    }, [props.files])

    const handleChange = (selectorFiles: FileList) => {
        let arr = Array.from(selectorFiles);

        if (validateFiels(arr)) {
            var joined = selectedFiles.concat(arr);
            setSelectedFiles(joined);

            if (props.setFilesUpload !== undefined)
                props.setFilesUpload(joined);
        }
    };
    const validateFiels = (files: File[]): boolean => {
        for (let i = 0; i < files.length; i = i + 1) {
            if (props.extensions !== undefined) {
                var ext = files[i].name.split('.').pop()?.toLowerCase();
                if (ext !== undefined && !props.extensions?.includes(ext)) {
                    setErrorFile(`O arquivo ${files[i].name} não é permitido, pois deve ter uma das seguintes extensões: ${props.extensions.join(", ")}.`);
                    return false
                } else if (props.maxFileSizeMb !== undefined) {
                    var maxFileSizeBytes = props.maxFileSizeMb * 1024 * 1024;
                    if (files[i].size > maxFileSizeBytes) {
                        setErrorFile(`O arquivo ${files[i].name} deve ter o tamaanho máximo de ${props.maxFileSizeMb} MB`);
                        return false
                    }
                }
            }

        }
        setErrorFile(undefined);

        return true;
    }
    const removeFile = (file: File) => {

        var newFiles = selectedFiles.filter(function (fileFilter) {
            return fileFilter !== file
        });

        setSelectedFiles(newFiles);
        if (props.setFilesUpload !== undefined)
            props.setFilesUpload(newFiles);
    };
    return (
        <React.Fragment>
            <input
                // accept="application/pdf"
                style={{ display: 'none' }}
                id="raised-button-file"
                multiple
                type="file"
                onChange={(e: any) => handleChange(e.target.files)}
            />
            <label htmlFor="raised-button-file">
                <Button className="btn-choose" variant="contained" fullWidth
                    component="span" >
                    Selecionar Arquivo(s)
                </Button>
            </label>

            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                {selectedFiles?.map((file, index) => (

                    <ListItem
                        key={file.name}
                        secondaryAction={
                            <IconButton edge="end" color="error" aria-label="comments" onClick={() => {
                                removeFile(file);
                            }}>
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        }
                        disablePadding
                    >
                        <ListItemButton role={undefined} dense>
                            <ListItemText id={file.name} primary={`${file.name}`} />
                        </ListItemButton>
                    </ListItem>
                ))}

            </List>
            {errorFile && (
                <FormHelperText error>
                    {errorFile}
                </FormHelperText>
            )}
        </React.Fragment>

    );
}